import { Form, Switch } from "antd";
import React from "react";

const ShowPopulationCount: React.FC = () => {
  return (
    <Form.Item
      name="hasPopulationCount"
      label="Show Population Count?"
      valuePropName="checked"
    >
      <Switch />
    </Form.Item>
  );
};

export default ShowPopulationCount;
